'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Log data constants for the Feed
 */
var WEB_APP = exports.WEB_APP = 'Web';

var ORIGIN_KEY = exports.ORIGIN_KEY = 'origin';
var FEED_CONTENT_ID_KEY = exports.FEED_CONTENT_ID_KEY = 'feedContentId';

var FEED_ORIGIN = exports.FEED_ORIGIN = 'Feed';
var USER_TIMELINE_ORIGIN = exports.USER_TIMELINE_ORIGIN = 'UserTimeline';
var TEAM_PROFILE_ORIGIN = exports.TEAM_PROFILE_ORIGIN = 'TeamProfile';
var FEATURED_ATHLETES_ORIGIN = exports.FEATURED_ATHLETES_ORIGIN = 'FeaturedAthletes';
var MINI_PROFILE_ORIGIN = exports.MINI_PROFILE_ORIGIN = 'MiniProfile';

var WHO_REACTED_BASE = 'WhoReacted';
var WHO_REACTED_FEED_ORIGIN = exports.WHO_REACTED_FEED_ORIGIN = WHO_REACTED_BASE + FEED_ORIGIN;
var WHO_REACTED_USER_TIMELINE_ORIGIN = exports.WHO_REACTED_USER_TIMELINE_ORIGIN = WHO_REACTED_BASE + USER_TIMELINE_ORIGIN;
var WHO_REACTED_TEAM_PROFILE_ORIGIN = exports.WHO_REACTED_TEAM_PROFILE_ORIGIN = WHO_REACTED_BASE + TEAM_PROFILE_ORIGIN;

var TAG_BASE = 'Tag';
var TAG_FEED_ORIGIN = exports.TAG_FEED_ORIGIN = TAG_BASE + FEED_ORIGIN;
var TAG_USER_TIMELINE_ORIGIN = exports.TAG_USER_TIMELINE_ORIGIN = TAG_BASE + USER_TIMELINE_ORIGIN;
var TAG_TEAM_PROFILE_ORIGIN = exports.TAG_TEAM_PROFILE_ORIGIN = TAG_BASE + TEAM_PROFILE_ORIGIN;

var CARD_TAG_MODAL = exports.CARD_TAG_MODAL = 'CardTagModal';

var FEED_CONTENT = exports.FEED_CONTENT = 'FeedContent'; // Sumo Op

var ENTER_IMMERSIVE = exports.ENTER_IMMERSIVE = 'Enter Immersive';
var MINIMUM_VIDEO_PLAY_TIME_MS = exports.MINIMUM_VIDEO_PLAY_TIME_MS = 2000;

var IMMERSIVE_INTERCOM_EVENT = exports.IMMERSIVE_INTERCOM_EVENT = 'Web Immersive Experience';